"use client";
import { useRef, useState, useEffect } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { GetList } from "../../../hook/getList.tsx";
import BranchItems from "./EventItems.tsx";
import React from "react";
import { Spin, Popconfirm } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Pagination from "../../../component/Pagination/index.tsx";
import { useNavigate } from "react-router-dom";
import { request } from "../../../api/request.tsx";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface PageChangeEvent {
  selected: number;
}

const ListEvent = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [isReload, setIsReload] = useState(false);
  const topRef = useRef<HTMLDivElement | null>(null);

  const { data, search, loadMore, loading } = GetList<any>({
    url: "event/get-list-event",
    isLazy: true,
    dependencies: searchValue,
    dependencies1: isReload,
    params: {
      limit: 10,
    },
  });
  const list = data?.results || [];
  const totalPages = data?.totalPages || 0;
  
  const handlePageChange = ({ selected }: any) => {
    const newPage = selected + 1;
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
      loadMore(newPage);
    }
  };

  const handleSearch = () => {
    setPage(1);
    search(searchValue);
  };

  const handleDeleteEvent = async (eventId: string) => {
    try {
      const response = await request(
        "/event/delete-event",
        { id: eventId },
        "POST"
      );
      
      if (response?.status) {
        toast.success("Xóa sự kiện thành công!");
        setIsReload(!isReload);
      } else {
        toast.error(response?.message || "Đã có lỗi xảy ra, vui lòng thử lại sau");
      }
    } catch (error) {
      toast.error("Đã có lỗi xảy ra, vui lòng thử lại sau");
    }
  };
  
  const buttonRef = useRef<HTMLButtonElement>(null);

  const renderUser = (item: any, index: number) => {
    return <BranchItems item={item} key={index} index={index} />;
  };

  useEffect(() => {
    search("");
  }, []);
  return (
    <div className="px-10">
      <div className="text-2xl text-center text-[pink] font-bold my-5">
        DANH SÁCH SỰ KIỆN
      </div>
      <div className="flex justify-center w-full">
        <div
          className="
        flex 
        items-center 
        border-[1.5px] 
        md:w-[50%]
        w-full
        rounded-lg
        pl-2
        border-[pink]
        mb-3
        "
        >
          <input
            className="flex w-full px-2 py-2 outline-none "
            placeholder="Tìm kiếm sự kiện"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
          <button
            onClick={handleSearch}
            className="bg-[pink] px-3 h-full rounded-tr-lg rounded-br-lg"
          >
            <AiOutlineSearch size={26} />
          </button>
        </div>
      </div>
      <div className="mt-6 max-w-7xl mx-auto w-full px-4">
        {loading ? (
          <div className="w-full h-full flex justify-center items-center mt-24">
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <div className="bg-white rounded-3xl shadow-lg border-2 border-[pink]/20 overflow-hidden">
            
            {list?.length > 0 ? (
              <>
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-[pink]">
                      <tr>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">STT</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Hình ảnh</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Tên sự kiện</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Mô tả</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Ngày bắt đầu</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Ngày kết thúc</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Vị trí</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item: any, index: number) => (
                        <tr
                          key={index}
                          className="border-b border-gray-100 hover:bg-[pink]/5 transition-colors"
                        >
                          <td className="py-4 px-6 font-medium text-gray-700">{(page - 1) * 10 + index + 1}</td>
                          <td className="py-4 px-6">
                            <div className="w-16 h-16 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
                              {item?.url ? (
                                <img 
                                  src={item?.url} 
                                  alt={item?.name} 
                                  className="w-full h-full object-cover"
                                  onError={(e) => {
                                    const target = e.currentTarget as HTMLImageElement;
                                    const nextSibling = target.nextElementSibling as HTMLElement;
                                    target.style.display = 'none';
                                    nextSibling.style.display = 'flex';
                                  }}
                                />
                              ) : (
                                <span className="text-gray-400 text-xs">---</span>
                              )}
                              <div className="hidden w-full h-full items-center justify-center">
                                <span className="text-gray-400 text-xs">---</span>
                              </div>
                            </div>
                          </td>
                          <td className="py-4 px-6">
                            <div className="font-semibold text-gray-800">{item?.name || item?.title || "-"}</div>
                          </td>
                          <td className="py-4 px-6">
                            <div className="text-gray-600 max-w-xs truncate">{item?.description || "-"}</div>
                          </td>
                          <td className="py-4 px-6">
                            <div className="text-gray-600">{item?.timeStart ? new Date(item.timeStart).toLocaleDateString('vi-VN') : "-"}</div>
                          </td>
                          <td className="py-4 px-6">
                            <div className="text-gray-600">{item?.timeEnd ? new Date(item.timeEnd).toLocaleDateString('vi-VN') : "-"}</div>
                          </td>
                          <td className="py-4 px-6">
                            <div className="text-gray-600 font-medium">{item?.index || "-"}</div>
                          </td>
                          <td className="py-4 px-6">
                            <div className="flex gap-2">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/admin/add-event", { state: { item } });
                                }}
                                className="px-4 py-2 text-sm rounded-lg bg-[pink] text-white hover:bg-[pink]/80 transition-all duration-200 shadow-sm hover:shadow-md"
                              >
                                Chỉnh sửa
                              </button>
                              <Popconfirm
                                title="Xóa sự kiện"
                                description="Bạn có chắc muốn xóa sự kiện này không?"
                                okText="Xác nhận"
                                cancelText="Không"
                                onConfirm={() => handleDeleteEvent(item?.id)}
                              >
                                <button
                                  onClick={(e) => e.stopPropagation()}
                                  className="px-4 py-2 text-sm rounded-lg bg-red-500 text-white hover:bg-red-600 transition-all duration-200 shadow-sm hover:shadow-md"
                                >
                                  Xóa
                                </button>
                              </Popconfirm>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                  <Pagination
                    pageCount={totalPages}
                    onPageChange={handlePageChange}
                    currentPage={page}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={2}
                  />
                </div>
              </>
            ) : (
              <div className="text-center text-gray-500 py-16">
                <div className="text-4xl mb-4">📅</div>
                <div className="text-lg font-medium">Không có sự kiện nào</div>
                <div className="text-sm">Vui lòng thử lại sau</div>
              </div>
            )}
          </div>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default ListEvent;
